const resource = 'companies'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  sendDocument(id, params) {
    return $axios.$post(`/${resource}/${id}/documents`, params, {
      headers: { 'content-type': 'multipart/form-data' },
    })
  },

  getServiceName: name => 'companyService',
})
